import type { WShopBestsellerProductsTranslations } from "./pl";

export const de: WShopBestsellerProductsTranslations = {
  title: "Bestseller",
  showAll: "Alle anzeigen",
  noProducts: "Keine Bestseller.",
};
